import type { GQL_ID } from '@@partner:types:graphql'
import type { OrderInfo } from '@@partner:types:app'

import React from 'react'
import { useCurrentCart } from './CartContext'

import CartProductCard from './CartProductCard'
import './Cart.scss'

export interface CartProps {
  order: OrderInfo
  readOnly?: boolean
  onDeleteProduct?: (id: GQL_ID) => void
  onUpdateAmount?: (id: GQL_ID, amount: number) => void
}

export default function Cart ({
  readOnly = false,
  onDeleteProduct,
  onUpdateAmount
}: CartProps) {
  const { currentShopCart, currentShopID } = useCurrentCart()

  return (
    <div className="Cart">
      {currentShopID &&
        currentShopCart.products?.map((product) => (
          <CartProductCard
            key={product.id}
            shop_id={currentShopID}
            id={product.id}
            amount={product.amount}
            total={product.total || 0}
            readOnly={readOnly}
            onChangeAmount={(id, amount) => {
              onUpdateAmount?.(id, amount)
            }}
            onDeleteProduct={onDeleteProduct}
          />
        ))}
    </div>
  )
}
